import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import customizationReducer from './customizationSlice';
import analyticsReducer from './analyticsSlice';
import assessmentsReducer from './assessmentsSlice';
import feedbackReducer from './feedbackSlice';
import logsReducer from './logsSlice';
import notificationsReducer from './notificationsSlice';
import promptsReducer from './promptsSlice';
import userReducer from './userSlice';
import roleReducer from './roleSlice';
import dashboardReducer from './dashboardSlice';
import emailReducer from './emailSlice';
import supportTicketReducer from './supportTicketSlice';
import leadersReducer from './leadersSlice';
import personalityArchetypesReducer from './personalityArchetypesSlice';

const rootReducer = combineReducers({
    auth: authReducer,
    customization: customizationReducer,
    analytics: analyticsReducer,
    assessments: assessmentsReducer,
    feedback: feedbackReducer,
    logs: logsReducer,
    notifications: notificationsReducer,
    prompts: promptsReducer,
    users: userReducer,
    role: roleReducer,
    dashboard: dashboardReducer,
    email: emailReducer,
    supportTickets: supportTicketReducer,
    leaders: leadersReducer,
    personalityArchetypes: personalityArchetypesReducer
});

export default rootReducer;